import React, {Component} from 'react';
import {Dimmer, Icon, Loader, Popup, Segment, Table,} from 'semantic-ui-react'

import DataShow from './DataShow';

import getNestedObject from 'xAppLib/helpers/getNestedObject'
import {cls} from "../../views/NUI/utils";

/*
	 This list table component is depreceated
	 use DataListTable from DataListTable for typescript safety and react hooks
*/
class ListTable extends Component {

	render() {
		const { data, loading = true , children, inverted=false,color=null,fixed=false, style ={}, className } = this.props
		const itm_rows = !Array.isArray(children) ? [children] : children
		return (
			<Segment className="list-table" basic style={{padding:0,...style}}>
			    <Dimmer active={loading} inverted={!inverted}>
			      <Loader />
			    </Dimmer>

			<Table striped selectable color={color} inverted={inverted}  fixed={fixed} style={{margin:0,height:'100%'}} className={className}>
				<Table.Header>
					<Table.Row>
				       {itm_rows[0](null)}
					</Table.Row>
				</Table.Header>
				<Table.Body>
					{/*loading && !data && <Table.Row><Table.Cell singleLine><Loader active inline/></Table.Cell></Table.Row>*/}
					{data && this.data_render() }
				</Table.Body>
			</Table>
		</Segment>
			
		);
	}

	data_render() {
		const { children, data, showWarnings = true, onRowClick } = this.props
		const itm_rows = !Array.isArray(children) ? [children] : children

		return data && Array.isArray(data) && data.length && data.reduce((flat, r,i)=>{
			return flat.concat(itm_rows.map((row_render_func,rowIndex)=> row_render_func(r,i) && <Table.Row className={cls('relative', onRowClick && 'cursor-pointer', this.props.rowClass?.(r, i))} key={(this.props.rowKey?.(r) || i)+'-'+rowIndex+"-view-col"} warning={showWarnings && (r.is_script!=undefined&&!r.is_script || r.show_row_warning)} error={r.show_row_error} disabled={r.show_row_disabled} onClick={onRowClick && (() => onRowClick(r, i))} >
				 { row_render_func(r,i)}
			</Table.Row>))
		}, []) || <Table.Row><Table.Cell colSpan={100}>No records</Table.Cell></Table.Row>

	}
 
}

class ListTableCell extends Component {
	render() {
		const { row , index, visible = true, singleLine = false, colSpan, collapsing, label, path, type, f, children, onClick, funcs, style, extra_show, className } = this.props

		if (!visible)
			return null

		// Applied to both the header and body cells - a width class has to be on the header for the
		// browser to size the column by it, and on the body cell for `fixed` tables.
		const cell_class = cls(className, f?.className) || undefined

		const header = !row
		if (!row)
			return <Table.HeaderCell singleLine={singleLine} colSpan={colSpan} className={cell_class}>{f && f.name || label}{f?.tttip && <Popup content={f.tttip} trigger={<Icon name='info circle' size='small' color='grey' />} />}{extra_show}</Table.HeaderCell>

		let value = children || '-'
		if (f) {
			value = DataShow.show_data_field(row, {...f, funcs},null,null,null,false, this.props)
		}
		else if (type) {
			value = DataShow.show_data_field(row, {...this.props, funcs}) 
		}
		else if (row && path) {
			value = getNestedObject( row, path, '.' )
		}

		return (
			<Table.Cell collapsing={collapsing} singleLine={singleLine} colSpan={colSpan} onClick={onClick} style={style} className={cell_class}>{children && typeof children === 'function' ? children(value,row,index) : value }</Table.Cell>
		);
	}

}

ListTable.Cell = ListTableCell

const equalWithoutChildren = (prev, next) => {
  return Object.keys(prev).every(key => {
    if (key === 'children') return true;
    return prev[key] === next[key];
  });
};

/**
 * Please note that this list will only re-render if the props change. 
 * If you have children that use out-of-scope dependencies, please add them as props as well.
 */
ListTable.Memoed = React.memo(ListTable, equalWithoutChildren);

export default ListTable;
